(function ($) {
  $(document).ready(function() {

    $.fn.wsMenu = function (options) {
      var opt = $.extend({
        openButton: '.mobile-menu-open-button',
      }, options);

      const menuElement = this;
      const menuContainer = menuElement.find('.mega-menu__container');
      const openButtonElement = $(opt.openButton);
      const closeButtonElement = menuElement.find('.top .mobile-menu-button');
      const mainPanel = menuElement.find('.mega-menu__main-list');
      const subNavContainer = menuElement.find('.mega-menu__sub-nav');

      openButtonElement.on('click', function(e) {
        e.preventDefault();
        menuElement.addClass('open');
        $('body').addClass('menu-open');
      });

      closeButtonElement.on('click', function(e) {
        e.preventDefault();
        menuElement.removeClass('open');
        $('body').removeClass('menu-open');
        setTimeout(function() {
          menuElement.find('.active').removeClass('active');
          menuElement.find('.is-hidden').removeClass('is-hidden');
          menuContainer.removeClass('level-3-active');
        }, 500);
      });

      menuElement.on('click', '.mega-menu__main-link[data-id]', function(e) {
        if (!$(this).hasClass('active')) {
          e.preventDefault();
          showNextMenuLevel($(this));
        }
      });

      menuElement.on('click', '.mega-menu__main-link.active', function(e) {
        e.preventDefault();
        showPreviousMenuLevel($(this));
      });

      menuElement.on('click', '.mega-menu__sub-nav-panel .has-children > a', function(e) {
        e.preventDefault();
        const parentPanel = $(this).closest('.mega-menu__sub-nav-panel');
        const panelId = $(this).data('id');
        const targetPanel = $('#'.concat(panelId));

        parentPanel.removeClass('active').addClass('is-hidden');
        targetPanel.addClass('active');
        menuContainer.addClass('level-3-active');
      });

      menuElement.on('click', '.mega-menu__panel-back-button', function(e) {
        e.preventDefault();
        const currentPanel = $(this).closest('.mega-menu__sub-nav-panel');
        const targetPanelId = $(this).data('target-id');
        const targetPanel = $('#'.concat(targetPanelId));

        currentPanel.removeClass('active');
        targetPanel.removeClass('is-hidden').addClass('active');
        menuContainer.removeClass('level-3-active');
      });

      function showNextMenuLevel(clickedLink) {
        clickedLink.addClass('active');
        mainPanel.addClass('active');
        clickedLink.closest('li').addClass('active');
        const panelId = clickedLink.data('id');
        const targetPanel = $('#'.concat(panelId));
        if (targetPanel.length) {
          subNavContainer.addClass('active');
          setTimeout(function() {
            targetPanel.addClass('active');
          }, 275);
        }
      }

      function showPreviousMenuLevel(activeLink) {
        const panelId = activeLink.data('id');
        const targetPanel = $('#'.concat(panelId));
        activeLink.removeClass('active');
        targetPanel.removeClass('active');
        $('.mega-menu__sub-nav-panel.active').removeClass('active');
        $('.mega-menu__sub-nav-panel.is-hidden').removeClass('is-hidden');
        mainPanel.removeClass('active');
        mainPanel.find('li.active').removeClass('active');
        subNavContainer.removeClass('active');
        menuContainer.removeClass('level-3-active');
      }

      return this;
    };
  });
})(jQuery);
